import angular from 'angular';
import './confirm.global.css';
import { bind } from 'hyperhtml/umd';

/**
 * Displays a confirmation modal before calling the specified function
 */
export default angular
  .module('app.directives.confirm', [])
  .directive('confirm', ConfirmDirective);

function ConfirmDirective() {
  const modal = document.createElement('upd-dialog');
  modal.classList.add('confirm-directive');

  function confirm(data, confirmed) {
    function cleanup() {
      modal.close();
      modal.remove();
    }
    function yes() {
      cleanup();
      confirmed();
    }
    function no() {
      cleanup();
    }

    bind(modal)`
      <div class="confirm">
        <div class="confirm-body">
          <span class="content">${data.content}</span>
          ${
            data.warning
              ? `
              <div class="warning">
                <span>${data.warning}</span>
              </div>
              `
              : ''
          }
        </div>
        <div class="confirm-footer">
          <button onclick=${no} class="btn btn-sm btn-full-mobile btn-link">${
      data.btnCancelText
    }</button>
          <button onclick=${yes} class="btn btn-sm btn-full-mobile btn-primary">${
      data.btnConfirmText
    }</button>
        </div>
      </div>
    `;
    document.body.appendChild(modal);
    modal.showModal();
  }

  return {
    scope: {
      confirmed: '&confirm',
      cancelConfirm: '<',
      content: '@',
      btnConfirmText: '@',
      btnCancelText: '@',
      warning: '@?',
    },
    link: function(scope, element) {
      element.on('click', () => {
        let data = {
          content: scope.content,
          warning: scope.warning,
          btnConfirmText: scope.btnConfirmText || 'Yes',
          btnCancelText: scope.btnCancelText || 'No',
        };

        scope.cancelConfirm
          ? scope.confirmed()
          : confirm(data, scope.confirmed);
      });
    },
  };
}
